import React from "react";
import "./Modal.css";

const Modal = ({
  isOpen,
  onClose,
  height,
  width,
  backgroundColor,
  borderRadius,
  boxShadow,
  marginTop,
  closeButtonStyle,
  children,
  ...rest
}) => {
  if (!isOpen) return null;

  const modalStyle = {
    height: height || "23.625rem",
    width: width || "38rem",
    backgroundColor: backgroundColor || "#fff",
    borderRadius: borderRadius || "0.75rem",
    boxShadow: boxShadow || "0 0.25rem 0.375rem rgba(0, 0, 0, 0.1)",
    marginTop: marginTop || "2.5rem",
    ...rest,
  };

  return (
    <div className="modal-overlay">
      <button className="modal-close" onClick={onClose} style={closeButtonStyle}>
        ✕
      </button>
      <div className="modal-container" style={modalStyle}>
        {children}
      </div>
    </div>
  );
};

export default Modal;